import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { ChangeAreaBlock } from '../blocks/ChangeAreaBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const ChangeAreasLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { changeAreas } = useTimelineData()

  return (
    <LayerWrapper zIndex={zIndex}>
      {changeAreas.map((item, index) => (
        <ChangeAreaBlock key={index} changeArea={item} index={index} />
      ))}
    </LayerWrapper>
  )
}

export default ChangeAreasLayer
